import { useMemo, useState, useEffect } from 'react'
import { TYPES_DEVICE_SIZE } from 'utils/constants'

const useMediaQueryBySize = (queryString) => {
  const query = useMemo(() => window.matchMedia(queryString), [queryString])
  const [matches, setMatches] = useState(query?.matches)
  useEffect(() => {
    const listener = (e) => setMatches(e.matches)
    query.addEventListener('change', listener)
    return () => query.removeEventListener('change', listener)
  }, [query])
  return matches
}
const useMediaQuery = (queryString) => {
  const match = useMediaQueryBySize(queryString)

  const desktopQuery = `(width > ${TYPES_DEVICE_SIZE.LAPTOP})`
  const laptopQuery = `(${TYPES_DEVICE_SIZE.TABLET} < width <= ${TYPES_DEVICE_SIZE.LAPTOP})`
  const mobileQuery = `(width <= ${TYPES_DEVICE_SIZE.MOBILE})`
  const tabletQuery = `(${TYPES_DEVICE_SIZE.MOBILE} < width <= ${TYPES_DEVICE_SIZE.TABLET})`

  const isDesktop = useMediaQueryBySize(desktopQuery)
  const isLaptop = useMediaQueryBySize(laptopQuery)
  const isMobile = useMediaQueryBySize(mobileQuery)
  const isTablet = useMediaQueryBySize(tabletQuery)

  if (queryString) {
    return match
  }
  return { isDesktop, isLaptop, isMobile, isTablet }
}

export default useMediaQuery
